/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setNavMenu.js
 * 
 * グローバルメニュー用スクリプト
 * 
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import { slideToggle } from "../setSlideToggle";

/**
 * 孫メニューアコーディオン
 */
var parent = document.querySelectorAll(".sub-menu >li.menu-item-has-children");
var child = document.querySelector(".sub-menu .sub-menu");
var Main = document.getElementsByTagName('main');

var nodeParent = Array.prototype.slice.call(parent, 0);
var mainElement = Main.item(0);

nodeParent.forEach(function (element) {
    element.addEventListener("mouseover", () => {
        element.classList.add("is-active");
        if (window.getComputedStyle(child).display === "none") {
            slideToggle(child);
        }
    },
        false
    );
    mainElement.addEventListener("mouseover", () => {
        element.classList.remove("is-active");
        if (window.getComputedStyle(child).display != "none") {
            slideToggle(child);
        }
    },
        false
    );
});

